import store from "../store";

export default async (to, from, next) => {
  document.title =
    (to.meta.title || to.name) +
      " | " +
      store.getters?.settings?.profile?.name || "";

  // Função para pegar o pai imediato
  const getImmediateParentName = (route) => {
    const len = route.matched.length;
    if (len >= 2) return route.matched[len - 2].name;
    return null;
  };

  const toParent = getImmediateParentName(to);
  const fromParent = getImmediateParentName(from);

  // Só rola se:
  // - O pai imediato mudou
  // - E o novo pai NÃO for "Main"
  if (toParent !== fromParent || toParent === "Main") {
    window.scrollTo(0, 0);
  }

  const requiresAuth = to.meta.requiresAuth || false;
  const preventAuth = to.meta.preventAuth || false;
  const authenticated = store.getters.authenticated;

  if (to.name !== "SignUp" && !authenticated && to.query.code) {
    return next({
      name: "SignUp",
      query: { code: to.query.code },
    });
  }

  if (requiresAuth && !authenticated) return next("/auth");

  if (preventAuth && authenticated) return next("/");

  next();
};
